// extracted by mini-css-extract-plugin
module.exports = {"controlButtons":"ControlButtons_controlButtons__1_QA2"};